import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { CardType } from '../enums/card-type.enum';

@Injectable({ providedIn: 'root' })
export class TenantService {
	private reservedRoutes = ['no-subdomain', 'login', 'signup', 'reset-password'];

	public getTenant(): string | null {
		const { hostname, pathname } = window.location;

		const segments = pathname.split('/').filter(Boolean);

		if (this.reservedRoutes.includes(segments[0])) {
			return null;
		}

		if (segments.length === 0) {
			return null;
		}

		return segments[0];
	}
}
